module.exports = __webpack_public_path__ + "assets/img/remote.117ad8cb.webp";